// #region Imports
import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { useClientAppSettings, useToken } from "../../libs/hooks";
// #endregion

// #region Component
/**
 * Renders children when the user has a session token; otherwise `<Navigate replace />` to login (React Router v6).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export function RequireAuth({
  children,
}: PropsWithChildren): JSX.Element {
  const { app } = useClientAppSettings();
  const { token } = useToken();
  if (token) {
    return <>{children}</>;
  }
  return <Navigate to={`/login?redirect=/${app.AppName}`} replace />;
}
// #endregion
